import { render, staticRenderFns } from "./MedicationInfoItem.vue?vue&type=template&id=eba63fd2&"
import script from "./MedicationInfoItem.vue?vue&type=script&lang=js&"
export * from "./MedicationInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports